<img
  class="info-logo"
  [src]="showTooltip ? './../../../../assets/images/icons/info-white.svg' : './../../../../assets/images/icons/info.svg'"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  alt="Info logo" />
<div *ngIf="showTooltip" class="u-tooltip">
  <div class="u-tooltip-text">
    {{ tooltipText }}
  </div>
</div>
